import { render, staticRenderFns } from "./ViewAffiliateEntry.vue?vue&type=template&id=1d5b2d2c&scoped=true"
import script from "./ViewAffiliateEntry.vue?vue&type=script&lang=js"
export * from "./ViewAffiliateEntry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5b2d2c",
  null
  
)

export default component.exports